import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitPerformanceMarch20KmResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitMarch20KmResultInput;
}>;


export type SubmitPerformanceMarch20KmResultMutation = (
  { __typename: 'Mutation' }
  & { submitMarch20KmResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitMarch20KmResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'PerformanceResult' }
      & March20kmPerformanceResultFragment
    )> }
  ) }
);

export type March20kmPerformanceResultFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<{ __typename: 'SuperAdminUser' } | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | (
    { __typename: 'March20kmResult' }
    & March20kmPerformanceResultDataFragment
  ) | { __typename: 'SocResult' } | { __typename: 'WeightResult' } }
);

export type March20kmPerformanceResultDataFragment = (
  { __typename: 'March20kmResult' }
  & Pick<SchemaTypes.March20kmResult, 'timingSec' | 'result'>
);

export const March20kmPerformanceResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment March20kmPerformanceResultData on March20kmResult {
  timingSec
  result
}
    `;
export const March20kmPerformanceResultFragmentDoc = /*#__PURE__*/ gql`
    fragment March20kmPerformanceResult on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on March20kmResult {
      ...March20kmPerformanceResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    ${March20kmPerformanceResultDataFragmentDoc}`;
export const SubmitPerformanceMarch20KmResultDocument = /*#__PURE__*/ gql`
    mutation SubmitPerformanceMarch20KmResult($input: SubmitMarch20KmResultInput!) {
  submitMarch20KmResult(input: $input) {
    ... on SubmitMarch20KmResultSuccessfulResponse {
      result {
        ...March20kmPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${March20kmPerformanceResultFragmentDoc}`;
export type SubmitPerformanceMarch20KmResultMutationFn = Apollo.MutationFunction<SubmitPerformanceMarch20KmResultMutation, SubmitPerformanceMarch20KmResultMutationVariables>;

/**
 * __useSubmitPerformanceMarch20KmResultMutation__
 *
 * To run a mutation, you first call `useSubmitPerformanceMarch20KmResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPerformanceMarch20KmResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPerformanceMarch20KmResultMutation, { data, loading, error }] = useSubmitPerformanceMarch20KmResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPerformanceMarch20KmResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPerformanceMarch20KmResultMutation, SubmitPerformanceMarch20KmResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPerformanceMarch20KmResultMutation, SubmitPerformanceMarch20KmResultMutationVariables>(SubmitPerformanceMarch20KmResultDocument, options);
      }
export type SubmitPerformanceMarch20KmResultMutationHookResult = ReturnType<typeof useSubmitPerformanceMarch20KmResultMutation>;
export type SubmitPerformanceMarch20KmResultMutationResult = Apollo.MutationResult<SubmitPerformanceMarch20KmResultMutation>;
export type SubmitPerformanceMarch20KmResultMutationOptions = Apollo.BaseMutationOptions<SubmitPerformanceMarch20KmResultMutation, SubmitPerformanceMarch20KmResultMutationVariables>;